import { createFileRoute, Link } from "@tanstack/react-router";

import {
  ExternalAuthorityLink,
  LegalCallout,
  LegalDocument,
  LegalSection,
} from "@/features/legal/LegalDocument";
import { LEGAL_RESPONSIBLE } from "@/features/legal/legal-config";

export const Route = createFileRoute("/contacto")({
  head: () => ({
    meta: [
      { title: "Contacto y responsable | Socrattica" },
      {
        name: "description",
        content:
          "Identidad del responsable de Socrattica, correo, soporte y tiempos estimados de respuesta.",
      },
    ],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <LegalDocument
      eyebrow="Identidad y contacto"
      title="Hay una persona responsable detrás de Socrattica."
      summary="Consulta la identidad del responsable, el canal directo de correo, el soporte con radicado y los tiempos estimados de respuesta."
      showDocumentNav={false}
    >
      <LegalCallout title="Responsable de Socrattica">
        <p>
          <strong>{LEGAL_RESPONSIBLE.name}</strong>
          <br />
          {LEGAL_RESPONSIBLE.capacity}
          <br />
          Domicilio y operación: {LEGAL_RESPONSIBLE.country}
          <br />
          Correo: <a href={`mailto:${LEGAL_RESPONSIBLE.email}`}>{LEGAL_RESPONSIBLE.email}</a>
        </p>
      </LegalCallout>

      <LegalSection id="canales" title="1. Canales de atención">
        <ul>
          <li>
            <strong>Correo general, compras y privacidad:</strong>{" "}
            <a href={`mailto:${LEGAL_RESPONSIBLE.email}`}>{LEGAL_RESPONSIBLE.email}</a>.
          </li>
          <li>
            <strong>Soporte con trazabilidad:</strong>{" "}
            <Link to="/productos/tickets">centro privado de tickets</Link>. Genera número de
            referencia, fecha y seguimiento en la cuenta.
          </li>
          <li>
            <strong>Acceso a compras:</strong> revisa primero <Link to="/cuenta">Mi cuenta</Link>{" "}
            con el correo verificado usado en el pedido.
          </li>
        </ul>
      </LegalSection>

      <LegalSection id="respuesta" title="2. Tiempos estimados">
        <p>
          Nuestro objetivo es enviar una primera respuesta útil dentro de{" "}
          <strong>{LEGAL_RESPONSIBLE.responseTime}</strong>, de lunes a viernes no festivos en
          Colombia. Los casos técnicos o de pago que dependan de un tercero pueden requerir tiempo
          adicional; te informaremos el estado mediante el mismo canal.
        </p>
        <p>
          Las consultas de datos personales se atienden en máximo diez días hábiles, prorrogables en
          los casos legales por cinco días hábiles adicionales. Los reclamos de datos se atienden en
          máximo quince días hábiles, prorrogables por ocho días hábiles adicionales, conforme a la{" "}
          <Link to="/legal/privacidad">política de privacidad</Link>.
        </p>
      </LegalSection>

      <LegalSection id="incluir" title="3. Qué incluir para ayudarte mejor">
        <ul>
          <li>Correo de la cuenta o de la compra.</li>
          <li>Número de pedido, ticket o transacción, si existe.</li>
          <li>Nombre exacto del producto y una descripción clara del problema.</li>
          <li>Capturas sin contraseñas ni datos completos de tarjeta.</li>
          <li>La solución que solicitas: acceso, corrección, retracto, reembolso u otra.</li>
        </ul>
      </LegalSection>

      <LegalSection id="autoridades" title="4. Autoridades y escalamiento">
        <p>
          Queremos resolver primero tu solicitud directamente. Esto no limita tu derecho a acudir a
          la{" "}
          <ExternalAuthorityLink href="https://www.sic.gov.co/">
            Superintendencia de Industria y Comercio
          </ExternalAuthorityLink>{" "}
          o a otra autoridad competente después de cumplir los requisitos aplicables.
        </p>
      </LegalSection>
    </LegalDocument>
  );
}
